import { Navigate, useLocation } from "react-router-dom";

const AuthWrapper = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("oeson_auth");
  let roles = [];
  try {
    roles = JSON.parse(localStorage.getItem("oeson_roles") || "[]");
  } catch (_) {
    roles = [localStorage.getItem("oeson_role")].filter(Boolean);
  }
  const isMentorWorkspaceUser = roles.includes("Instructor") || roles.includes("Admin");
  const location = useLocation();

  if (!isAuthenticated || !isMentorWorkspaceUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AuthWrapper;
